<template>
  <div class="info-box">
    <div class="overflow-y-auto">
      <div class="grid gap-x-5 gap-y-3" style="grid-template-columns: auto 1fr">
        <c_cell title="开票主体" :value="state.model?.invoice_entity" />
        <li class="gap-x-10 grid" style="grid-template-columns: 1fr auto">
          <c_cell title="开票种类">
            <c_status
              arrName="Invoice_Type"
              :value="state.model?.invoice_type"
              :key="state.model?.invoice_type"
            />
          </c_cell>
          <c_cell title="开票金额" class="mr-5">
            <template #default>
              <c_money
                :value="state.model?.amount"
                :key="state.model?.amount"
                bold
                :prefix="false"
                :size="16"
              />
            </template>
          </c_cell>
        </li>
        <c_cell title="发票抬头" :value="state.model?.invoice_title" />
        <c_cell title="纳税人识别号" :value="state.model?.tax_no" />
        <c_cell title="电话号码" :value="state.model?.phone || '-'" />
        <c_cell title="单位地址" :value="state.model?.address || '-'" />
        <c_cell title="开户银行" :value="state.model?.opening_bank || '-'" />
        <c_cell title="银行账户" :value="state.model?.bank_account || '-'" />
        <c_cell title="备注" :value="state.model?.remark || '-'" />
      </div>
      <ul class="font-bold text-sm flex items-center gap-x-1 mt-3 mb-3">
        <li
          style="
            width: 3px;
            background-color: var(--el-color-primary);
            height: 12px;
            border-radius: 10px;
          "
        >
          &nbsp;
        </li>
        操作记录
      </ul>
      <el-timeline class="!text-xs" style="padding-left: 5px">
        <el-timeline-item
          v-for="item in state.meetingInvoiceLogList"
          :key="item"
          type="primary"
          hide-timestamp
        >
          <div class="flex gap-x-3">
            <text>{{ item.create_time }}</text>
            <text>{{ item.add_admin_name }}</text>
            <text class="text-gray-400" style="margin-left: -12px">
              {{ "/" + item.add_department_name }}
            </text>
            <text class="text-primary">{{ item.title }}</text>
          </div>
          <c_cell
            title="操作说明"
            v-if="item.remark"
            :value="item.remark"
            :size="12"
            class="mt-1"
          />
          <el-card class="mt-2" shadow="always" v-if="item.status == 2">
            <ul class="flex gap-x-3">
              <c_cell title="发票号" :value="state.model?.invoice_no" />
              <c_cell title="开票日期" :value="state.model?.invoice_date" />
              <c_cell title="开票备注" :value="state.model?.invoice_remark" />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.model?.invoice_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.model?.invoice_attachment"
                :value="state.model?.invoice_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
          <el-card class="mt-2" shadow="always" v-if="item.status == 3">
            <ul class="flex gap-x-3">
              <c_cell title="到款流水" :value="state.model?.receipt_sn" />
              <c_cell title="到款日期" :value="state.model?.receipt_date" />
              <c_cell title="到款备注" :value="state.model?.receipt_remark" />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.model?.receipt_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.model?.receipt_attachment"
                :value="state.model?.receipt_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
          <el-card class="mt-2" shadow="always" v-if="item.status == 4">
            <ul class="flex gap-x-3">
              <c_cell
                title="红冲发票号码"
                :value="state.model?.reverse_invoice_no"
              />
              <c_cell
                title="红冲开票日期"
                :value="state.model?.reverse_invoice_date"
              />
              <c_cell
                title="红冲开票备注"
                :value="state.model?.reverse_invoice_remark"
              />
            </ul>
            <c_cell
              title="附件"
              class="mt-1"
              v-if="state.model?.reverse_invoice_attachment?.length > 0"
            >
              <c_UploadFile
                :key="state.model?.reverse_invoice_attachment"
                :value="state.model?.reverse_invoice_attachment"
                :showAdd="false"
                :showText="true"
              />
            </c_cell>
          </el-card>
        </el-timeline-item>
        <!-- <el-timeline-item hollow type="primary" hide-timestamp>
          <div class="flex gap-x-3">
            <text>2026-4-03 20:46</text>
            <text>李丽</text>
            <text>财务部</text>
            <text class="text-primary">确认开票</text>
          </div>
          <el-card class="mt-2" shadow="always">
            <ul class="flex gap-x-3">
              <c_cell title="发票号" value="343434343" />
              <c_cell title="开票日期" value="2026-07-23" />
              <c_cell title="开票备注" value="差额21325" />
            </ul>
            <el-table-column
              label="附件"
              prop="remark"
              :formatter="$tab_TextFormat"
              v-if="state.attachment?.length > 0"
            >
              <template #default="{ row }">
                <c_UploadFile
                  :key="state.attachment"
                  :value="state.attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </template>
            </el-table-column>
          </el-card>
        </el-timeline-item>
        <el-timeline-item hollow type="primary" hide-timestamp>
          <div class="flex gap-x-3">
            <text>2026-4-03 20:46</text>
            <text>李丽</text>
            <text>财务部</text>
            <text class="text-primary">确认到款</text>
          </div>
          <el-card class="mt-2" shadow="always">
            <ul class="flex gap-x-3">
              <c_cell title="到款流水" value="343434343" />
              <c_cell title="到款日期" value="2026-07-23" />
              <c_cell title="到款备注" value="差额21325" />
            </ul>
            <el-table-column
              label="附件"
              prop="remark"
              :formatter="$tab_TextFormat"
              v-if="state.attachment?.length > 0"
            >
              <template #default="{ row }">
                <c_UploadFile
                  :key="state.attachment"
                  :value="state.attachment"
                  :showAdd="false"
                  :showText="true"
                />
              </template>
            </el-table-column>
          </el-card>
        </el-timeline-item> -->
      </el-timeline>
    </div>
    <!--状态（0审批中 1开票中 2已开票 3已到账 4已红冲 5已作废 6不通过 7已取消）-->
    <div class="submit-box px-2.5" v-if="state.model?.status == 0">
      <el-button type="danger" size="large" @click="onCancel"> 取消 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_invoice_search, meeting_invoice_cancel } from "@/http/meeting";
import { ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        onLoadDetail();
      }
    });

    //加载详情
    const onLoadDetail = () => {
      if (props.id) {
        meeting_invoice_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, flowApproveStepList, meetingInvoiceLogList } =
              res.data?.data || {};
            state.model = info;
            state.flowApproveStepList = flowApproveStepList;
            state.meetingInvoiceLogList = meetingInvoiceLogList;
          }
        });
      }
    };

    //取消
    const onCancel = () => {
      ElMessageBox.prompt(
        `您确定<strong>取消</strong>当前开票申请吗？`,
        "提示",
        {
          confirmButtonText: "确定取消",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
          inputPattern: /\S/,
          inputType: "textarea",
          inputPlaceholder: "请输入取消说明",
          inputErrorMessage: "请输入取消说明",
        },
      ).then(({ value }) => {
        meeting_invoice_cancel({
          id: props.id,
          cancel_msg: value,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoadDetail();
            }, 500);
          });
        });
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadDetail,
      onCancel,
    };
  },
};
</script>
<style scoped></style>
